import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// import store from '../store';
import { fetchAnswerSteaming } from './conversationApi';
import { getConversations, getBillings } from './preferences/preferenceApi';
import { setConversations } from './preferences/preferenceSlice';

const initialState = {
    queries: [],
    status: 'idle',
    conversationId: null
};

// const API_STREAMING = import.meta.env.VITE_API_STREAMING === 'true';
const API_STREAMING = true;

export const fetchAnswer = createAsyncThunk('fetchAnswer', async ({ question, model, project }, { dispatch, getState }) => {
    const state = getState();
    if (state.preference) {
        if (API_STREAMING) {
            await fetchAnswerSteaming(
                question,
                model,
                state.preference.apiKey,
                '',
                state.conversation.queries,
                state.conversation.conversationId,
                project,
                (event) => {
                    const data = JSON.parse(event.data);
                    // console.log('data------', data)
                    // check if the 'end' event has been received
                    if (data.type === 'end') {
                        // set status to 'idle'
                        getBillings();
                        dispatch(conversationSlice.actions.setStatus('idle'));
                        getConversations(project)
                            .then((fetchedConversations) => {
                                dispatch(setConversations(fetchedConversations));
                            })
                            .catch((error) => {
                                console.error('Failed to fetch conversations: ', error);
                            });
                    } else if (data.type === 'source') {
                        // check if data.metadata exists
                        let result;
                        if (data.metadata && data.metadata.title) {
                            const titleParts = data.metadata.title.split('/');
                            result = {
                                title: titleParts[titleParts.length - 1],
                                text: data.doc
                            };
                        } else {
                            result = { title: data.doc, text: data.doc };
                        }
                        dispatch(
                            updateStreamingSource({
                                index: state.conversation.queries.length - 1,
                                query: { sources: [result] }
                            })
                        );
                    } else if (data.type === 'id') {
                        dispatch(
                            updateConversationId({
                                query: { conversationId: data.id }
                            })
                        );
                    } else {
                        const result = data.answer;
                        // console.log("data.answer", data.answer)
                        dispatch(
                            updateStreamingQuery({
                                index: state.conversation.queries.length - 1,
                                query: { response: result }
                            })
                        );
                    }
                }
            );
        }
    }
    return {
        conversationId: null,
        title: null,
        answer: '',
        query: question,
        result: '',
        sources: []
    };
});

export const conversationSlice = createSlice({
    name: 'conversation',
    initialState,
    reducers: {
        addQuery(state, action) {
            state.queries.push(action.payload);
        },
        setConversation(state, action) {
            state.queries = action.payload;
        },
        updateStreamingQuery(state, action) {
            const { index, query } = action.payload;
            // console.log(query)
            if (query.response !== undefined) {
                if (query.response === 'Đã vượt quá hạn mức cho phép. Vui lòng kiểm tra hóa đơn !') {
                    state.status = 'failed';
                    state.queries[state.queries.length - 1].error = 'Đã vượt quá hạn mức cho phép. Vui lòng kiểm tra hóa đơn !';
                } else {
                    state.queries[index].response = (state.queries[index].response || '') + query.response;
                }
            } else {
                console.log('ERRORRRRRRRRRRRRR');
                // console.log(query)
                state.queries[index] = {
                    ...state.queries[index],
                    ...query
                };
            }
        },
        updateConversationId(state, action) {
            state.conversationId = action.payload.query.conversationId ?? null;
        },
        updateStreamingSource(state, action) {
            const { index, query } = action.payload;
            if (!state.queries[index].sources) {
                if (query.sources[0].title !== 'youteach.txt') {
                    state.queries[index].sources = [query.sources[0]];
                }

                // state.queries[index].sources = [query.sources[0]];
            } else {
                if (query.sources[0].title !== 'youteach.txt') {
                    state.queries[index].sources.push(query.sources[0]);
                }
                // state.queries[index].sources.push(query.sources[0]);
            }
        },
        updateQuery(state, action) {
            const { index, query } = action.payload;
            state.queries[index] = {
                ...state.queries[index],
                ...query
            };
        },
        setStatus(state, action) {
            state.status = action.payload;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchAnswer.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAnswer.rejected, (state, action) => {
                state.status = 'failed';
                state.queries[state.queries.length - 1].error = 'Đã có lỗi xảy ra. Vui lòng thử lại sau.';
            });
    }
});

export const selectQueries = (state) => state.conversation.queries;

export const selectStatus = (state) => state.conversation.status;

export const { addQuery, updateQuery, updateStreamingQuery, updateConversationId, updateStreamingSource, setConversation } =
    conversationSlice.actions;
export default conversationSlice.reducer;
